export default "__VITE_ASSET__53b5462d__"